import {
  SidePanelLayout,
  SidePanelProfile,
  SidePanelSectionAvailability,
} from './layout.types';

export const BUILTIN_DEFAULT_PROFILE_ID = 'default';

export function makeBuiltinDefaultProfile(
  sections: SidePanelSectionAvailability[],
): SidePanelProfile {
  const layoutSections: SidePanelLayout['sections'] = {};

  for (const { key, availableKeys, defaultVisibleKeys } of sections) {
    const defaultVisible = new Set(defaultVisibleKeys);

    layoutSections[key] = {
      properties: availableKeys
        .filter((propertyKey) => defaultVisible.has(propertyKey))
        .map((propertyKey) => ({ key: propertyKey, visible: true })),
    };
  }

  return {
    id: BUILTIN_DEFAULT_PROFILE_ID,
    name: 'Default',
    source: 'builtin',
    layout: { hideEmpty: false, sections: layoutSections },
  };
}
